import { render, staticRenderFns } from "./ActionsDialog.vue?vue&type=template&id=453d0e42"
import script from "./ActionsDialog.vue?vue&type=script&lang=js"
export * from "./ActionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports